<template>
  <v-row>
    <v-col
      cols="12"
      md="4"
    >
      <v-text-field
        id="routing_number"
        v-model="routingNumber"
        label="Routing Number"
        disabled
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <v-text-field
        id="account_number"
        v-model="accountNumber"
        label="Account Number"
        disabled
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <WaterfallTestValidifiOptionsDialog
        :lead-data="leadData"
        :campaigns="campaigns"
        @save-options="updateNumbers"
      />
    </v-col>
  </v-row>
</template>

<script>
import WaterfallTestValidifiOptionsDialog from './WaterfallTestValidifiOptionsDialog.vue';

export default {

  components: {
    WaterfallTestValidifiOptionsDialog,
  },

  props: {
    leadData: {
      type: Object,
      required: true,
    },
    campaigns: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      routingNumber: '',
      accountNumber: '',
      forceValidifi: true,
      validifiModal: false,
    };
  },
  methods: {
    showValidifiModal() {
      this.validifiModal = true;
    },
    updateNumbers(options) {
      this.routingNumber = options.routingNumber;
      this.accountNumber = options.accountNumber;

      // eslint-disable-next-line vue/no-mutating-props
      this.leadData.routingnumber = options.routingNumber;
      // eslint-disable-next-line vue/no-mutating-props
      this.leadData.accountnumber = options.accountNumber;
    },
  },
};
</script>

<style></style>
